// Central source of truth for business/legal details (from GST Registration Certificate)
export const business = {
  legalName: 'Kumkum Devi',
  tradeName: 'Thread & Textile India',
  gstin: '10CRNPD6356G1ZY',
  constitution: 'Proprietorship',
  email: 'threadntextilen@gmail.com',
  address: {
    line1: '1st Floor, Flat No-403, Ratna Niwas',
    line2: 'New Rampur, Mahendru',
    city: 'Patna',
    state: 'Bihar',
    pin: '800006',
    country: 'India'
  },
  registeredSince: '23 December 2024'
};

export const fullAddress = `${business.address.line1}, ${business.address.line2}, ${business.address.city}, ${business.address.state} - ${business.address.pin}, ${business.address.country}`;
